/* sb-dc-tplcurve.js — 템플릿을 열 때 «곡선 글자» 와 «글꼴» 을 되살린다.
   V0.0.2 (2026-09-07)

   무엇이 문제였나
   ───────────────
   1) 곡선. 템플릿 SVG 의 곡선 글자는 <text data-dc-curve="50"> (자체 쪽지) 또는
      <textPath> (SVG 표준) 로 적혀 온다. 그런데 SVG 를 레이어로 뜯는 변환기는
      글자마다 무조건  assets/sb-dc-aug.js:2899   L.curveDeg = 0;
      로 못박고, 쪽지도 textPath 도 읽지 않는다. 그래서 편집기에서 늘 일직선이다.
   2) 글꼴. 변환기는 글꼴을 알아내려고 SVG 를 document.body 에 잠깐 붙이고
      getComputedStyle 로 묻는데, sb-dc-arial.css 의 «body *» 규칙이 그 <text> 에도
      걸려 답이 언제나 Arial 이었다 → pickFont(aug 2762) 가 전부 Archivo 로.
      그 규칙은 V0.0.2 에서 :not(svg *) 를 붙여 고쳤다. 그래도 pickFont 는 기본
      6종만 알므로, 고르개 35종(sb-dc-fonts.js, window.__dcFonts) 의 나머지는
      여기서 채운다.

   어떻게 하나
   ───────────
   테마에서 템플릿을 실제로 그리는 곳은 전부 tpl.build(W,H) 를 부른다.
     sb-dc-aug.js:3153 applyTplFromUrl · sb-dc-tplfix.js:244 buildFitted · :398
   그리고 window.__dcTemplateList 가 돌려주는 객체는 aug 내부 remoteTpls 와 같은
   참조다(aug 2509-2521). 그래서 목록이 건네질 때 각 템플릿의 build 를 한 번 감싸
   두면 세 경로가 모두 고쳐진다 (sb-dc-tplnames.js:105 · 옛 sb-dc-tpldoc.js 와
   같은 방식). 레이어를 폴링하며 뒤늦게 고치지 않으므로 경쟁이 없다.

   감싼 build 는 원래 결과의 글자 레이어를 이름으로 찾아
     · curveDeg   ← data-dc-curve, 없으면 textPath 호에서 역산
     · fontFamily ← 파일의 글꼴이 고르개 35종 안에 있을 때만
   을 채운 «복사본» 을 돌려준다 (cutSvg 가 캐시하는 원본 배열은 건드리지 않는다).

   이름 규칙은 aug 2873 그대로: data-dc-name, 없으면 글자 앞 18자.
   한 파일 안에 같은 이름이 둘이면 그 이름은 통째로 버린다.

   글꼴은 캔버스가 «받아지기 전» 에 그리면 대체 글꼴로 굳는다(sb-dc-fonts.js 주석).
   그래서 지도를 만들자마자 __dcEnsureFont 로 미리 받고, 받아진 뒤
   updateLayer(id, {fontFamily}) 로 한 번 되그린다 — fonts.js 의 repaint 와 같다.

   안전망: ?tpl= 로 들어왔는데 10초가 지나도 우리 손을 거친 레이어가 없으면
   (aug 가 먼저 그렸고 tplfix 가 다시 세우지 않은 경우) 문서를 이름으로 한 번만
   채운다. 레이어 id 당 1회 — 손님이 슬라이더를 0 으로 되돌린 것을 덮지 않는다.

   진단: window.__dcTplCurve()
   자리: layout/design-center.liquid 의 sb-dc-tplnames.js «바로 뒤», defer.
   ponytail: textPath 파일은 변환기가 상자를 호 크기로 재서 글자가 약 0.1in 아래로
   앉는다. 눈에 띄면 heightIn 을 글자 높이로 줄이는 보정을 fill() 에 한 줄 더한다. */
(function () {
  'use strict';

  if (window.__dcTplCurve) return;

  var S = window.__dcSupabase || {
    url: 'https://uktrkymhgmzlufzxsavf.supabase.co',
    anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrdHJreW1oZ216bHVmenhzYXZmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODc4Nzg0MjAsImV4cCI6MjEwMzQ1NDQyMH0.BBMLGRs0BkBhb45ZkY5MddnslJT355lQyBZvjMe7ndY'
  };
  var UUIDRE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  /* 원본에 적힌 곡률이 그 자리에 비해 과해서, 넣으면 오히려 나빠지는 템플릿.
     ⚠ 코드가 아니라 «자료» 문제다. 저장소 SVG 의 값을 고치면 여기서 뺀다. */
  var SKIP = {
    '8aad907b-52c4-4a38-96a6-487dbdb9b4ea': 'Political 10 · 슬로건이 초상화에 묻힘'
  };

  var state = { wrapped: false, asked: 0, maps: 0, applied: 0, fonts: 0, rescued: null, why: '' };
  window.__dcTplCurve = function () {
    var o = JSON.parse(JSON.stringify(state));
    o.detail = maps;
    return o;
  };
  window.__dcTplCurve.parse = function (t) { return parse(t); };   // 테스트 훅

  var maps = {};        // uuid → { 이름: {curve, font} }  |  false (없음·실패)
  var asked = {};

  function uuidOf(id) { return String(id || '').replace(/^r_/, ''); }
  function norm(s) { return String(s || '').replace(/["']/g, '').replace(/\s+/g, '').toLowerCase(); }

  /* ------------------------------------------------------------ 글꼴 */

  var BUILT_IN = ['Anton', 'Archivo', 'Oswald', 'Bebas Neue', 'Montserrat', 'Noto Sans KR'];
  function knownFont(name) {
    var list = window.__dcFonts || BUILT_IN;
    // 일러스트레이터는 'Anton-Regular' · 'BebasNeue-Bold' 처럼 적는다
    var k = norm(String(name).replace(/-(regular|bold|italic|bolditalic|medium|light|semibold|extrabold|black)$/i, ''));
    if (!k) return '';
    for (var i = 0; i < list.length; i++) if (norm(list[i]) === k) return list[i];
    return '';
  }
  function fontOfOne(el) {
    try { return knownFont((getComputedStyle(el).fontFamily || '').split(',')[0]); }
    catch (e) { return ''; }
  }
  /* 일러스트레이터는 글꼴 class 를 <text> 가 아니라 안쪽 <tspan> 에 단다 */
  function fontOf(el) {
    var f = fontOfOne(el);
    if (f) return f;
    var inner = el.querySelectorAll('tspan, textPath');
    for (var i = 0; i < inner.length; i++) { f = fontOfOne(inner[i]); if (f) return f; }
    return '';
  }
  function ensure(f) {
    try { if (window.__dcEnsureFont) return window.__dcEnsureFont(f); } catch (e) {}
    return Promise.resolve();
  }

  /* ------------------------------------------------------------ 곡선 */

  function clamp(d) { return Math.max(-180, Math.min(180, d)); }

  function circleOf(A, B, C) {
    var d = 2 * (A.x * (B.y - C.y) + B.x * (C.y - A.y) + C.x * (A.y - B.y));
    if (Math.abs(d) < 1e-9) return null;
    var a2 = A.x * A.x + A.y * A.y, b2 = B.x * B.x + B.y * B.y, c2 = C.x * C.x + C.y * C.y;
    var x = (a2 * (B.y - C.y) + b2 * (C.y - A.y) + c2 * (A.y - B.y)) / d;
    var y = (a2 * (C.x - B.x) + b2 * (A.x - C.x) + c2 * (B.x - A.x)) / d;
    return { x: x, y: y, r: Math.sqrt((A.x - x) * (A.x - x) + (A.y - y) * (A.y - y)) };
  }

  /* 쪽지가 있으면 그 값. 없고 <textPath> 면 관리자 패널 deriveCurves 와 같은 식:
     호 위 세 점으로 원을 맞추고, 아홉 점이 그 원 위에 있는지 본 뒤(물결 제외),
     각도 = 글자 길이 ÷ 반지름. 원의 중심이 호 «아래» 면 위로 볼록(∩) = 양수. */
  function curveOf(svg, t) {
    var d = parseFloat(t.getAttribute('data-dc-curve'));
    if (isFinite(d) && d) return clamp(d);
    var tp = t.querySelector('textPath');
    if (!tp) return 0;
    var href = tp.getAttribute('href') || tp.getAttribute('xlink:href') ||
      tp.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || '';
    if (href.charAt(0) !== '#') return 0;
    var path = svg.querySelector('[id="' + href.slice(1).replace(/"/g, '') + '"]');
    if (!path || !path.getTotalLength) return 0;
    var L, W;
    try { L = path.getTotalLength(); W = t.getComputedTextLength(); } catch (e) { return 0; }
    if (!(L > 0) || !(W > 0)) return 0;
    var at = function (f) { var p = path.getPointAtLength(L * f); return { x: p.x, y: p.y }; };
    var A = at(0), M = at(0.5), B = at(1);
    var c = circleOf(A, M, B);
    if (!c || !(c.r > 0) || !(L / c.r >= 0.15)) return 0;      // 8.6도 미만 = 직선
    for (var k = 1; k <= 9; k++) {
      var q = at(k / 10);
      var dd = Math.sqrt((q.x - c.x) * (q.x - c.x) + (q.y - c.y) * (q.y - c.y));
      if (Math.abs(dd - c.r) > c.r * 0.01) return 0;           // 물결·자유 곡선
    }
    var deg = W / c.r * 180 / Math.PI;
    if (!(deg >= 10)) return 0;
    deg = Math.min(180, Math.round(deg / 5) * 5);               // 슬라이더가 5도 단위
    return c.y > M.y ? deg : -deg;
  }

  /* ------------------------------------------------------------ 지도 */

  /* SVG 한 장 → { 레이어이름: {curve, font} }.  getComputedStyle 과
     getComputedTextLength 는 문서에 붙어 있어야 답하므로 aug 2828 과 같은
     숨은 host 에 잠깐 붙인다. */
  function parse(text) {
    var doc = new DOMParser().parseFromString(text, 'image/svg+xml');
    var root = doc.documentElement;
    if (!root || doc.querySelector('parsererror') || root.nodeName.toLowerCase() !== 'svg') return null;
    var svg = document.importNode(root, true);
    var host = document.createElement('div');
    host.style.cssText = 'position:absolute;left:-99999px;top:0;width:0;height:0;overflow:hidden';
    host.appendChild(svg);
    document.body.appendChild(host);
    var out = {}, n = 0;
    var put = function (key, entry) {
      if (!key || (!entry.curve && !entry.font)) return;
      if (key in out) { if (out[key]) n--; out[key] = null; return; }   // 겹치는 이름은 버린다
      out[key] = entry; n++;
    };
    try {
      var ts = svg.querySelectorAll('text');
      for (var i = 0; i < ts.length; i++) {
        var t = ts[i];
        var sp = t.querySelectorAll('tspan');
        if (sp.length > 1) {                       // aug 3025: 줄마다 따로 레이어
          for (var k = 0; k < sp.length; k++) {
            var stxt = (sp[k].textContent || '').trim();
            put(sp[k].getAttribute('data-dc-name') || stxt.slice(0, 18), { curve: 0, font: fontOf(sp[k]) });
          }
          continue;
        }
        var txt = (t.textContent || '').trim();
        var font = fontOf(t);
        // 각도 = 글자 길이 ÷ 반지름 이므로 길이는 진짜 글꼴로 재야 한다.
        // (inline style 은 sb-dc-arial.css 의 예외라 그대로 먹는다)
        if (font) {
          t.style.fontFamily = '"' + font + '"';
          var inner = t.querySelectorAll('tspan, textPath');       // 안쪽 class 가 이기므로 거기도
          for (var j = 0; j < inner.length; j++) inner[j].style.fontFamily = '"' + font + '"';
        }
        put(t.getAttribute('data-dc-name') || txt.slice(0, 18), { curve: curveOf(svg, t), font: font });
      }
    } finally {
      document.body.removeChild(host);
    }
    return n ? out : false;
  }

  function ask(ids) {
    var q = ids.map(encodeURIComponent).join(',');
    state.asked += ids.length;
    fetch(S.url + '/rest/v1/dc_templates?select=id,file_url&id=in.(' + q + ')', {
      headers: { apikey: S.anonKey, authorization: 'Bearer ' + S.anonKey }
    })
      // PostgREST 는 오류도 올바른 JSON 으로 준다 — 상태를 먼저 본다 (tplfix:150 의 함정)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (rows) {
        if (!rows) { state.why += ' row-not-ok'; ids.forEach(function (i) { maps[i] = false; }); return; }
        var seen = {};
        rows.forEach(function (r) {
          seen[r.id] = 1;
          if (!r.file_url) { maps[r.id] = false; return; }
          fetch(r.file_url)                                    // aug 가 받은 같은 주소 — 캐시
            .then(function (x) { return x.ok ? x.text() : null; })
            .then(function (t) {
              var m = t ? parse(t) : false;
              maps[r.id] = m || false;
              if (!m) return;
              state.maps++;
              for (var k in m) if (m[k] && m[k].font) ensure(m[k].font);   // 미리 받아 둔다
            })
            .catch(function (e) { maps[r.id] = false; state.why += ' svg-failed:' + (e && e.message); });
        });
        ids.forEach(function (i) { if (!seen[i]) maps[i] = false; });
      })
      .catch(function (e) { state.why += ' row-failed:' + (e && e.message); ids.forEach(function (i) { maps[i] = false; }); });
  }

  /* ------------------------------------------------------------ 채우기 */

  /* 받아진 뒤 되그리기. 레이어가 문서에 들어오는 시점이 build 보다 뒤이므로
     잠깐 기다렸다가 몇 번 찾아본다. */
  function repaint(id, font) {
    ensure(font).then(function () {
      var tries = 0;
      var tm = setInterval(function () {
        var a = window.__dcApi, ls = a && a.doc && a.doc.layers;
        var hit = false;
        if (ls) for (var i = 0; i < ls.length; i++) if (ls[i] && ls[i].id === id) { hit = true; break; }
        if (hit) {
          clearInterval(tm);
          try { if (a.updateLayer) a.updateLayer(id, { fontFamily: font }); } catch (e) {}
        } else if (++tries > 40) clearInterval(tm);              // 10초 — 그 레이어는 안 실렸다
      }, 250);
    });
  }

  function fill(layers, map) {
    if (!Array.isArray(layers)) return layers;
    return layers.map(function (l) {
      if (!l || l.type !== 'text') return l;
      var e = map[l.name];
      if (!e) return l;
      var o = null;
      if (e.curve && !l.curveDeg) {
        o = o || copy(l); o.curveDeg = e.curve; state.applied++;
      }
      if (e.font && l.fontFamily !== e.font) {
        o = o || copy(l); o.fontFamily = e.font; state.fonts++;
        repaint(o.id, e.font);
      }
      return o || l;
    });
  }
  function copy(l) { var o = {}; for (var k in l) o[k] = l[k]; return o; }

  function wrapBuild(t) {
    if (!t || !t.remote || t.__dcCurveWrapped || typeof t.build !== 'function') return;
    t.__dcCurveWrapped = true;
    var u = uuidOf(t.id), orig = t.build;
    t.build = function () {
      var layers = orig.apply(this, arguments);
      if (SKIP[u]) return layers;
      var map = maps[u];
      if (!map) return layers;                  // 아직 안 받았거나 채울 것이 없다
      try { return fill(layers, map); }
      catch (e) { state.why += ' fill-failed:' + (e && e.message); return layers; }
    };
  }

  /* ?tpl= 이면 목록을 기다리지 않고 바로 묻는다 (tplfix 가 1.5초 안에 세운다) */
  var urlTpl = '';
  var mUrl = /[?&]tpl=([^&]+)/.exec(location.search);
  if (mUrl) { try { urlTpl = decodeURIComponent(mUrl[1]); } catch (e) { urlTpl = mUrl[1]; } }
  if (!UUIDRE.test(urlTpl)) urlTpl = '';
  if (urlTpl && !SKIP[urlTpl]) { asked[urlTpl] = 1; ask([urlTpl]); }

  /* 목록이 «건네질 때» build 를 감싼다 */
  var installs = 0;
  var install = setInterval(function () {
    var prev = window.__dcTemplateList;
    if (typeof prev !== 'function') {
      if (++installs > 200) { clearInterval(install); state.why += ' no-list-fn'; }
      return;
    }
    clearInterval(install);
    state.wrapped = true;
    window.__dcTemplateList = function () {
      var list = prev.apply(this, arguments) || [];
      try {
        var need = [];
        for (var i = 0; i < list.length; i++) {
          var t = list[i];
          if (!t || !t.remote) continue;
          wrapBuild(t);
          var u = uuidOf(t.id);
          if (!(u in maps) && !asked[u] && UUIDRE.test(u) && !SKIP[u]) { asked[u] = 1; need.push(u); }
        }
        while (need.length) ask(need.splice(0, 50));
      } catch (e) { state.why += ' wrap-failed:' + (e && e.message); }
      return list;
    };
  }, 150);

  /* 안전망 — aug 의 applyTplFromUrl 은 목록을 세우자마자 build 를 부르므로(3179→3153,
     같은 동기 흐름) 우리 wrap 이 끼어들 틈이 없다. 판 모양이 같아 tplfix 가 다시
     세우지 않으면 그 첫 그림이 그대로 남는다 (배너류). 그래서 문서에 템플릿
     레이어가 보이는 즉시 이름으로 한 번 채운다. 값만 바꾸고 상자는 안 건드리므로
     tplfix 가 뒤에 다시 세워도 충돌하지 않는다 — 그때는 wrap 된 build 가 채운다. */
  if (urlTpl && !SKIP[urlTpl]) {
    var t0 = Date.now(), done = false;
    var net = setInterval(function () {
      if (done || Date.now() - t0 > 45000) { clearInterval(net); return; }
      /* V0.1.2 (2026-09-09): 변환기(sb-dc-aug.js)가 곡선·글꼴을 뜯는 자리에서 직접 넣으므로 이 안전망은 할 일이 없다.
         전에는 «붙인 게 없다» 며 45초 동안 0.4초마다 헛확인을 했다. 새 변환기가 보이면 바로 접는다. */
      if (typeof window.__dcCurveOfText === 'function') { done = true; state.rescued = 'aug'; clearInterval(net); return; }
      var map = maps[urlTpl];
      if (map === undefined) return;                             // 아직 받는 중
      if (map === false) { clearInterval(net); return; }         // 채울 것이 없다
      if (state.applied || state.fonts) { done = true; state.rescued = false; clearInterval(net); return; }
      var a = window.__dcApi, ls = a && a.doc && a.doc.layers;
      if (!a || !a.setDoc || !ls || !ls.length) return;
      var next = fill(ls, map);
      if (!state.applied && !state.fonts) return;                // 이름이 하나도 안 맞았다 — 더 기다린다
      done = true; clearInterval(net);
      try { a.setDoc({ layers: next }, false); state.rescued = true; }   // false = 되돌리기 단계 없음
      catch (e) { state.rescued = 'failed:' + (e && e.message); }
    }, 400);
  }

  addEventListener('pagehide', function () { clearInterval(install); });
})();
